import styled from 'styled-components';

export const animate = styled.div<{$cssStyle?: string}>`
position:absolute ;
width:100% ;
  pointer-events: none;
  ${p=>p.$cssStyle}
`;